if (!customElements.get('sc-logo-carousel')) {
  customElements.define(
    'sc-logo-carousel',
    class ScLogoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sc-logos-track]');
        this.prev = this.querySelector('[data-sc-logos-prev]');
        this.next = this.querySelector('[data-sc-logos-next]');
        this.arrows = this.querySelector('[data-sc-logos-arrows]');

        this.prev?.addEventListener('click', () => this.step(-1));
        this.next?.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizer = new ResizeObserver(() => this.update());
        this.resizer.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizer?.disconnect();
      }

      // One logo at a time, so each arrow press reads as a step.
      step(direction) {
        const slide = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (slide.offsetWidth + gap) });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = scrollWidth - clientWidth;
        if (this.arrows) this.arrows.hidden = max <= 1;
        if (this.prev) this.prev.disabled = scrollLeft <= 1;
        if (this.next) this.next.disabled = scrollLeft >= max - 1;
      }
    }
  );

  // Theme editor: bring the selected logo into view.
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('.sc-logos__slide');
    const carousel = slide?.closest('sc-logo-carousel');
    carousel?.track.scrollTo({ left: slide.offsetLeft - carousel.track.offsetLeft });
  });
}
